import { constantRoutes } from '@/router'

/**
 *
 * @param {*} roles
 * @param {*} route
 * @returns
 */
function childrenHasPermission(roles, route) {
  const str = JSON.stringify(route)
  let childrenhas = false
  if (route.hidden) {
    childrenhas = true
  } else {
    roles.map((item) => {
      if (str.indexOf(item) !== -1) {
        childrenhas = true
      }
    })
  }
  return childrenhas
}

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.permission) {
    return roles.some((role) => route.meta.permission.includes(role)) || route.meta.hasContent
  } else {
    if (route.children) {
      return childrenHasPermission(roles, route.children)
    } else {
      return true
    }
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  const res = []
  routes.forEach((route) => {
    const tmp = { ...route }
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles)
      }
      res.push(tmp)
    }
  })
  return res
}

const state = {
  routes: [],
  addRoutes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  }
}

const actions = {
  generateRoutes({ commit, rootState, state }, menus) {
    return new Promise((resolve) => {
      const rolesList = rootState.user.roles
      rootState.user.roles = rolesList
      let accessedRoutes = []
      accessedRoutes = filterAsyncRoutes(menus, rolesList)
      accessedRoutes.push({ path: '*', redirect: '/404', hidden: true })
      commit('SET_ROUTES', accessedRoutes)
      resolve(accessedRoutes)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
